import Dinero from 'dinero.js';
import type {Options} from 'dinero.js';

export enum ECurrencyFilterFormat {
	'NO_SYMBOL_DECIMAL' = '0,0.00',
	'NO_SYMBOL_WHOLE' = '0,0',
	'SYMBOL_DECIMAL' = '$0,0.00',
	'SYMBOL_WHOLE' = '$0,0',
}

type CurrencyFilterOptions = Options & {
	format?: ECurrencyFilterFormat;
};

export const CurrencyFilter = (amount: number | null | string, options: CurrencyFilterOptions = {
	format: ECurrencyFilterFormat.SYMBOL_DECIMAL,
}) => {
	if(amount === undefined || amount === null || amount === '' || typeof amount === 'string') {
		return '$-.--';
	}

	return Dinero({
		amount: amount,
		currency: 'USD',
	}).toFormat(options.format);
};
